import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import loginReducer from './loginReducer';
import metricsReducer from './metricsReducer';
import comparisonReducer from './comparisonReducer';
import accuracyRankingReducer from './accuracyRankingReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  customization: customizationReducer,
  login: loginReducer,
  metrics: metricsReducer,
  comparison: comparisonReducer,
  accuracyRanking: accuracyRankingReducer
});

export default reducer;
